import {
  Alert,
  Box,
  Button,
  Snackbar,
  SnackbarCloseReason,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Notification,
  notificationService,
} from 'src/services/NotificationService';

export const NotificationContainer: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState<Notification | null>();

  useEffect(() => {
    // Subscribe to global notifications
    const subscription = notificationService.notifications$.subscribe(
      (notif) => {
        setNotification(notif);
        setOpen(true);
      },
    );
    return () => subscription.unsubscribe();
  }, []);

  const handleClose = (
    event: React.SyntheticEvent<any> | Event,
    reason: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const handleCloseFromAlert = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={notification?.duration || 10000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Box>
        {notification && (
          <Alert
            severity={notification.type}
            sx={{ width: '100%' }}
            variant="filled"
            onClose={handleCloseFromAlert}
          >
            {notification?.message}
            {notification?.action && (
              <Button
                sx={{ ml: 1 }}
                onClick={() => {
                  if (notification.action) {
                    notification.action();
                  }
                  handleCloseFromAlert();
                }}
                data-qaid="notification-action-button"
              >
                {notification.actionText}
              </Button>
            )}
          </Alert>
        )}
      </Box>
    </Snackbar>
  );
};
